import { Switch } from '@ophelos/ui/components/switch';
import { setPresentationModeEnabled, usePresentationMode } from '@/lib/presentation-mode/store';

/**
 * Compact Demo mode toggle for a sidebar row. Analytics query keys carry the dataset,
 * so flipping it swaps caches without any invalidation.
 */
export function DemoModeSwitch() {
  const { enabled } = usePresentationMode();
  return (
    <Switch
      aria-label="Toggle demo mode"
      className="h-4 w-7 data-[state=unchecked]:bg-muted-foreground/25 [&_[data-slot=switch-thumb]]:size-3.5 [&_[data-slot=switch-thumb][data-state=checked]]:translate-x-2.75 [&_[data-slot=switch-thumb][data-state=unchecked]]:-translate-x-0.25"
      checked={enabled}
      onCheckedChange={setPresentationModeEnabled}
    />
  );
}
